import { isAfter } from 'date-fns';
import checkIsDateMidnight from 'helpers/checkIsDateMidnight';
import { z } from 'zod';

const schema = z
  .object({
    endDate: z.date(),
    startDate: z.date(),
  })
  .refine(
    (data) => {
      const isEndDateMidnight = checkIsDateMidnight(data.endDate);

      if (isEndDateMidnight) {
        return true;
      }

      return isAfter(data.endDate, data.startDate);
    },
    {
      message: 'error.date',
      path: ['endDate'],
    },
  );

export default schema;
